import { createRoutine } from 'redux-saga-routines'

export const SET = 'COUNTRY/SET'
export const CONTENT = createRoutine('COUNTRY/CONTENT')
